import { createSlice } from '@reduxjs/toolkit';

const initialState = {
}

export const settingsMainMenuSlice = createSlice({
    name: 'settingsMainMenu',
    initialState: initialState,
    reducers: {
        edit: (state, payload) => {
            if(payload.payload === "default"){
                state = initialState;
            }
            else {
                state = {
                    ...state, 
                    ...payload.payload
                };
            }
            console.log(state);
            return state;
        }
    },
})

export const { edit } = settingsMainMenuSlice.actions

export default settingsMainMenuSlice.reducer